import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { AnchorHTMLAttributes } from 'react';

interface LinkProps extends Omit<RouterLinkProps, 'to'>, Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string;
  target?: string;
}

export default function Link({ href, children, ...props }: LinkProps) {
  // External links
  if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:')) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }

  // Internal links
  return (
    <RouterLink to={href} {...props}>
      {children}
    </RouterLink>
  );
}

